import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ToasterComponent } from './toaster/toaster.component';
import { TOAST_DEDUP_WINDOW, TOAST_DURATION } from '../config/global.config';

interface ToastOptions {
  redirectTo?: string,
  duration?: number,
  verticalPosition?: 'top' | 'bottom',
  horizontalPosition?: 'start' | 'center' | 'end' | 'left' | 'right',
  variant?: string,
  variantTitle?: string,
  actionLabel?: string,
  actionCallback?: () => void
}
@Injectable({ providedIn: 'root' })
export class CommonService {
  defaultOptions : ToastOptions = {
    duration: TOAST_DURATION,
    verticalPosition: 'top',
    horizontalPosition: 'center'
  }

  /** Tracks the last toast shown, to suppress duplicates fired in quick
   *  succession (e.g. the global interceptor and an effect both reacting to the
   *  same failure). */
  private lastToast: { key: string; time: number } | null = null;

  constructor(private _snackBar: MatSnackBar, private router: Router, private ngZone: NgZone) {}

  showToast(message: string | string[], status: 'INFO' | 'SUCCESS' | 'ERROR' | 'WARNING' = 'INFO', options: ToastOptions = this.defaultOptions) {
    if (this.isDuplicate(message, status)) {
      return;
    }
    this.ngZone.run(() => {
      this._snackBar.openFromComponent(ToasterComponent, {
        data: {
          message,
          status,
          link: options.redirectTo,
          variant: options.variant,
          variantTitle: options.variantTitle,
          actionLabel: options.actionLabel,
          actionCallback: options.actionCallback,
        },
        duration: options.duration || TOAST_DURATION,
        verticalPosition: options.verticalPosition || 'top',
        horizontalPosition: options.horizontalPosition || 'center',
      });
    });
  }

  /** True when an identical toast was shown within the dedup window. */
  private isDuplicate(message: string | string[], status: string): boolean {
    const key = `${status}|${Array.isArray(message) ? message.join('§') : message}`;
    const now = Date.now();
    if (this.lastToast && this.lastToast.key === key && now - this.lastToast.time < TOAST_DEDUP_WINDOW) {
      this.lastToast = { key, time: now };
      return true;
    }
    this.lastToast = { key, time: now };
    return false;
  }
}
